import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoggingMessageService } from 'src/app/core/services/logging-message.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  selectedSubscriptionID: number;
  availableSubscriptions: string;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private logger: LoggingMessageService,
              public sessionService:StorageService) { }

  ngOnInit() {

    this.selectedSubscriptionID = this.sessionService.getSubscription();
    this.availableSubscriptions = this.sessionService.getSubscriptionsAvailable();

    this.logger.info('welcome.component.cs', 'ngOnInit', this.selectedSubscriptionID, this.availableSubscriptions, 'Welcome', '');
    // if ( (user !== null) && (typeof user !== 'undefined') ) {
    // const w: any = window;
    // this.pendoService.checkPendo(w);
    // }
  }


}
